export class DisableFormButton {
    form: HTMLFormElement;
    showLoaderInButton = (button: HTMLButtonElement) => {
        (button as HTMLButtonElement).disabled = true;
        button.classList.add('btn-loading');
    }
    handleUnload = (submitter: HTMLButtonElement) => {
        if (submitter) {
            this.showLoaderInButton(submitter);
        }
    };
    constructor(form: HTMLFormElement) {
        this.form = form;
        this.form.addEventListener("submit", (e) => {
            const submitter = (e as any).submitter;
            // Chrome / Firefox / Edge
            window.addEventListener("beforeunload", () => {
                this.handleUnload(submitter)
            });

            // Safari (iOS + macOS)
            window.addEventListener("pagehide", () => {
                this.handleUnload(submitter)
            });
        });
    }
}